import TestSection from './TestSection';
import TestSubsection from './TestSubsection';
import TestItem from './TestItem';
import { getTestCount } from './testingData';

/**
 * Universal component for displaying test sections
 * Takes data from testingData and dynamically generates UI
 */
const DynamicTestSection = ({ sectionData }) => {
  if (!sectionData || !sectionData.subsections) {
    return null;
  }

  const testCount = getTestCount(sectionData);

  return (
    <TestSection
      sectionId={sectionData.sectionId}
      title={sectionData.title}
      testCount={testCount}
    >
      {sectionData.subsections.map((subsection, subsectionIndex) => (
        <TestSubsection key={subsectionIndex} title={subsection.title}>
          {subsection.tests.map((test) => (
            <TestItem
              key={test.testId}
              testId={test.testId}
              sectionId={sectionData.sectionId}
              description={test.description}
              expectedResult={test.expectedResult}
            />
          ))}
        </TestSubsection>
      ))}
    </TestSection>
  );
};

export default DynamicTestSection;
